import { Samplers } from 'core/constants/enums/SamplersEnum.ts';

export const samplersConfig = {
	[Samplers.DPM_2M_KARRAS]: {
		label: Samplers.DPM_2M_KARRAS,
		name: Samplers.DPM_2M_KARRAS,
		showChip: true,
	},
	[Samplers.DPM_2M]: {
		label: Samplers.DPM_2M,
		name: Samplers.DPM_2M,
		showChip: true,
	},
	[Samplers.DPM_SDE_KARRAS]: {
		label: Samplers.DPM_SDE_KARRAS,
		name: Samplers.DPM_SDE_KARRAS,
	},
	[Samplers.DPM_2M_SDE_Karras]: {
		label: Samplers.DPM_2M_SDE_Karras,
		name: Samplers.DPM_2M_SDE_Karras,
	},
	[Samplers.DPM_SDE]: {
		label: Samplers.DPM_SDE,
		name: Samplers.DPM_SDE,
	},
	[Samplers.DPM_2S_A_KARRAS]: {
		label: Samplers.DPM_2S_A_KARRAS,
		name: Samplers.DPM_2S_A_KARRAS,
	},
	[Samplers.EULER_A]: {
		label: Samplers.EULER_A,
		name: Samplers.EULER_A,
	},
};
